<!--  -->
<template>
  <div class="progress_wrap">
      <div class="text" :style="textStyle">{{value}}%</div>
      <el-progress class="progress" :percentage="value" :show-text="false"></el-progress>
  </div>
</template>

<script>
export default {
  name:'ZlProgress',
  data() {
   return {
       aaa:0,
       textStyle:{}
   }
  },
  props:{
      value:0
  },
  watch:{
      value:{
        handler(val) {
            this.textStyle = {
                left:`${val-15}%`
            }
        },
        immediate: true,
        deep: true,
      }
  },
  created() {

  },
  mounted() {
  
  }
}
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.progress_wrap{
    width: 100%;
    height: 100%;
    position: relative;
    .progress{
        width: 100%;
        // margin-left: 10%;
    }
    .text{
        width: 30%;
        height: 20px;
        background:url(../../assets/image/learnmodel/tips.png)no-repeat center/100%;
        position: absolute;
        left:50%;
        top:10px;
        line-height: 16px;
        text-align: center;
        font-size: 10px;
        color: #FFF;
        font-weight: 600;
        text-indent: 0px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/component/progress.vue